const state = {
  checkboxMark:'no_filter',//勾选的类别：industry行业，concept概念，'no_filter'全部勾选
  top10State: false,
  activeBlock: {
    blockCode: '',
    blockName: ''
  },
  activeChooseBlock: {
    blockCode: '',
    blockName: '',
    level: 0
  },
  //板块下面的成分股
  blockStocks: [],
  //星空图中被点击的股票代码
  activeChooseStock: {
    stockCode: '',
    stockName: ''
  },
  hotRecommendClick: false //是否点击选择了热点推荐中的板块
};
const mutations = {
  setCheckboxMark(state,v){
    state.checkboxMark=v;
  },
  setTop10State(state, top10State) {
    state.top10State = top10State;
  },
  setActiveBlock(state, activeBlock) {
    state.activeBlock = activeBlock;
  },
  setActiveChooseBlock(state, activeChooseBlock) {
    state.activeChooseBlock = activeChooseBlock;
  },
  setNotActiveChooseStock(state, active) {
    state.activeChooseStock.active = active;
  },
  setBlockStocks(state, blockStocks) {
    state.blockStocks = blockStocks;
  },
  setActiveChooseStock(state, activeChooseStock) {
    state.activeChooseStock = activeChooseStock;
  },
  setHotRecommendClick(state, hotRecommendClick) {
    state.hotRecommendClick = hotRecommendClick;
  }
};
export default {
  state,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/mutations.js